import { ApiClient } from "../ApiClient";

/**
 * Fetch a list of articles
 * @param {string} url - The endpoint path
 * @returns {Promise<Response>}
 */
export const getArticleList = async (url) => {
  return ApiClient.get(url);
};

/**
 * Fetch a single article by ID
 * @param {string} url - The base endpoint path
 * @param {string|number} id - Article identifier
 * @returns {Promise<Response>}
 */
export const getSingleArticle = async (url, id) => {
  return ApiClient.get(`${url}/${id}`);
};

/**
 * Update an article
 */
export const updateArticle = async (url, id, data) => {
  return ApiClient.put(`${url}/${id}`, data);
};

/**
 * Get comments for a specific article
 */
export const getComments = async (url, id) => {
  return ApiClient.get(`${url}/${id}/comments`);
};

/**
 * Post a new comment or a reply
 * @param {string} url - The base endpoint path
 * @param {string|number} id - Article identifier
 * @param {string} text - The comment content
 * @param {number|null} parentId - The parent comment ID for replies
 * @returns {Promise<Response>}
 */
export const postComment = async (url, id, text, parentId) => {
  const payload = {
    content: text,
    parent: parentId, // This allows same function to handle replies too!
  };

  return ApiClient.post(`${url}/${id}/comments`, payload);
};
